import React from "react";
import "./about.css";
import ME from "../../assets/me-about.jpg";
import { FaAward } from "react-icons/fa";
import { MdOutlineCastForEducation } from "react-icons/md";
import { VscFolderLibrary } from "react-icons/vsc";

const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <MdOutlineCastForEducation className="about__icon" />
              <h5>Student</h5>
              <small>RTU, KOTA</small>
            </article>

            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Course</h5>
              <small>Computer Science</small>
            </article>

            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>4+ Completed</small>
            </article>
          </div>

          <p className="para">
            A meticulous and organized individual seeking an Entry-level
            position in the field of Software Development. I'm Currently
            pursuing B-Tect in Computer Science and Engineering from Rajasthan
            Technical University. Good knowledge of C, C++, Data Structure and
            Algorothms, HTML, CSS, JavaScript and React Js. Seeking an
            Internship or Full-Time oppurtunity as a Software Developer to
            pursue my passion for solving problems. I believe that the power of
            technology can make people's lives easier and that new frameworks
            and technology make developers more productive to the tech
            community.
          </p>

          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>

        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
